import Resource from './Resource';
import AppService from 'App/legacy/AppService';

class OpportunityEvents extends Resource {
	constructor() {
		super('events');
	}

	getEvents(
		opportunityId: number,
		limit?: number | null,
		offset?: number | null,
		notes?: boolean,
		search?: string | string[]
	) {
		const customerId = AppService.getCustomerId();
		return this._getRequest(`${opportunityId}/events`, {
			_url: `${customerId}/opportunities`,
			params: {
				limit,
				offset,
				notes: notes ? 1 : 0,
				...(search ? { search } : {})
			}
		}).then(res => res.data);
	}
}

const resource = new OpportunityEvents();

export default resource;
